import { BudgetLimitInput, IsTransportationCostProvidedRadio, MaxCompanionsAllowedInput, MenuSpecificationSelect, MessageTextArea, NgDaysCheckBoxes, NgTimePeriodInputs, NumberInput, PeriodInput, TeamSelect, UnitPriceInput } from "../../organisms/kuitan/DispatchRequestFormComponents";
import { useRequestMultiMonthDispatchFormForRestaurant } from "../../../hooks/kuitan/useRequestMultiMonthDispatchFormForRestaurant";
import { DispatchRequestForm } from "../../organisms/kuitan/DispatchRequestForm";
import { useRequestMultiMonthDispatchByRestaurant } from "../../../hooks/kuitan/useRequestMultiMonthDispatchByRestaurant";


type FormComponent = {
  component: React.ComponentType<any>;
  props: Record<string, any>;
}
export const RequestMultiMonthDispatchForRestaurant = () => {
  const { handleSubmit, register, control, isSubmitting, errors, watch } = useRequestMultiMonthDispatchFormForRestaurant();
  const onSubmit = useRequestMultiMonthDispatchByRestaurant()
  const formComponents: FormComponent[] = [
    { component: TeamSelect, props: { control, errors } },
    { component: PeriodInput, props: { register, errors } },
    { component: NumberInput, props: { register, errors } },
    { component: UnitPriceInput, props: { register, errors } },
    { component: MenuSpecificationSelect, props: { register, errors } },
    { component: BudgetLimitInput, props: { register, errors } },
    { component: MaxCompanionsAllowedInput, props: { register, errors } },
    { component: IsTransportationCostProvidedRadio, props: { control, errors } },
    { component: NgDaysCheckBoxes, props: { control, errors } },
    { component: NgTimePeriodInputs, props: { register, errors, watch } },
    { component: MessageTextArea, props: { register, errors } },
  ];
  return <DispatchRequestForm cardTitle='長期派遣依頼' formComponents={formComponents} onSubmit={handleSubmit(onSubmit)} isSubmitting={isSubmitting} />
};